module.exports = __webpack_public_path__ + "img/20190618162419204.61c6021d.png";